export default class CatalogVersionCompatibility {
  constructor() {
    this.form = document.getElementById('catalog_update_version_compatible_products');
    if ( this.form ) {
      this.checkboxes = document.querySelectorAll('.js-catalog-item-checkbox');
      this.search = null;
      this.filter = null;

      this.typeFilter = document.querySelector('#topFilter');
      this.searchElement = document.querySelector('#productNameSearch');

      this.init();
    }
  }

  init() {
    const me = this;

    this.checkboxes.forEach(checkbox => {
      const input = checkbox.querySelector('input');
      const select = checkbox.parentNode.querySelector('select');
      if (input.checked) {
        select.removeAttribute('disabled');
      } else {
        select.setAttribute('disabled', 'disabled');
      }

      checkbox.addEventListener('click', (e) => {
        let input;
        if (e.target.tagName === 'INPUT') {
          input = e.target;
        } else if (e.target.tagName === 'LABEL') {
          input = e.target.parentNode.querySelector('input');
        } else {
          input = e.target.querySelector('input');
          if (!input.hasAttribute('disabled')) {
            input.checked = !input.checked;
          }
        }
        if (!input.hasAttribute('disabled')) {
          me.activateSelect(input.checked, input.value);
        }
      });
    })

    if (this.searchElement.value) {
      this.search = this.searchElement.value;
      this.showFilteredElements(this.searchElement.value, 'search', this.filter);
    }

    $(this.typeFilter).chosen().change(this.filterByType.bind(this));
    this.searchElement.addEventListener('keyup', this.filterByName.bind(this));
  }

  filterByName(e) {
      this.search = e.target.value;
      return this.showFilteredElements(e.target.value, 'search', this.filter)
  }

  filterByType(e) {
    this.filter = e.target.value;
    return this.showFilteredElements(e.target.value, 'filter', this.search)
  }

  activateSelect = (active, id) => {
    const select = document.getElementById(this.form.id+'_product_version_' + id);
    if (active) {
      select.removeAttribute('disabled');
    } else {
      select.setAttribute('disabled', 'disabled');
    }
  }

  showFilteredElements = (value, element, usedOption) => {
    this.checkboxes.forEach(el => {
      const input = el.querySelector('input');
      const parent = el.parentNode;
      const searchAttr = (input.getAttribute('data-search') || '').toLowerCase();
      const filterAttr = (input.getAttribute('data-filter') || '').toLowerCase();
      if (value || usedOption) {
        let condition;
        if (element === 'search') {
          condition = usedOption ?
            (searchAttr.includes(value.toLowerCase()) &&
              filterAttr.includes(usedOption.toLowerCase())) :
            searchAttr.includes(value.toLowerCase())
        } else {
          condition = usedOption ?
            (filterAttr.includes(value.toLowerCase()) &&
              searchAttr.includes(usedOption.toLowerCase())) :
            filterAttr.includes(value.toLowerCase())
        }

        if (!condition) {
          parent.classList.add('d-none');
          parent.classList.remove('d-flex');
        } else {
          parent.classList.add('d-flex');
          parent.classList.remove('d-none');
        }
      } else {
        parent.classList.add('d-flex');
        parent.classList.remove('d-none');
      }
    });
  }
}
